<template>
  <div class="container">
    <div class="accounts">
      <p class="accounts__header">
        {{ $t('converter.inputData', { count: outputDataCount }) }}
      </p>

      <textarea
        v-model="inputData"
        ref="inputData"
        @scroll="syncIO"
        @input="converting"
        @blur="dataPositionStart"
        id="inputData"
        spellcheck="false"
      ></textarea>

      <div
        style="
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 10px;
          flex-wrap: wrap;
        "
      >
        <button @click="clearData" class="btn btn__clear unselect">
          {{ $t('global.clear') }}
        </button>
        <div class="separator unselect">
          <input
            v-model="separator.in"
            @input="converting"
            @focus="selectSeparator"
            class="modal-input"
            type="text"
            spellcheck="false"
          />
          <p>{{ $t('converter.separatorLine') }}</p>
        </div>
      </div>
    </div>

    <div class="result">
      <p class="result__header">
        {{ $t('converter.result', { count: outputDataCount }) }}
      </p>

      <!-- <textarea
        v-model="outputData"
        ref="outputData"
        @scroll="syncIO"
        spellcheck="false"
      ></textarea> -->

      <div
        @scroll="syncIO"
        ref="outputData"
        class="textarea"
        spellcheck="false"
        style="padding: 10px 0 10px 0"
      >
        <div v-if="separator.in">
          <div
            class="res converter"
            v-for="(item, index) in outputData"
            :key="item.id"
          >
            <span class="line unselect">{{ index + 1 }}.</span>
            {{ beautyOut(item.values) }}
            <!-- <span v-for="(str, index) in item.values" :key="index">
              {{ str.value }}
            </span> -->
          </div>
        </div>
      </div>

      <div
        style="
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 10px;
          flex-wrap: wrap;
          justify-content: space-between;
        "
      >
        <div class="separator unselect">
          <input
            v-model="separator.out"
            @input="saveSeparatorOut"
            @focus="selectSeparator"
            class="modal-input"
            type="text"
            spellcheck="false"
          />
          <p>{{ $t('converter.separatorLine') }}</p>
        </div>

        <div v-if="outputData.length" style="display: flex; gap: 10px">
          <button
            @mouseleave="$event.target._tippy.hide()"
            @click="copyTextToClipboard"
            v-tippy="{
              content: $t('converter.copyResult'),
              trigger: 'click',
              hideOnClick: false,
              theme: 'material',
              animation: 'shift-away',
            }"
            class="btn btn__copy unselect"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              style="fill: white"
            >
              <path
                d="M14 8H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V10c0-1.103-.897-2-2-2z"
              ></path>
              <path
                d="M20 2H10a2 2 0 0 0-2 2v2h8a2 2 0 0 1 2 2v8h2a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z"
              ></path></svg
            >{{ $t('global.copy') }}
          </button>

          <button
            @click="exportTXT"
            :disabled="waitResponseCSV"
            :class="{
              loading: waitResponseCSV,
              running: waitResponseCSV,
            }"
            class="btn btn__export unselect ld-ext-right"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              style="fill: white"
            >
              <path d="M11 16h2V7h3l-4-5-4 5h3z"></path>
              <path
                d="M5 22h14c1.103 0 2-.897 2-2v-9c0-1.103-.897-2-2-2h-4v2h4v9H5v-9h4V9H5c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2z"
              ></path>
            </svg>
            {{ $t('global.export') }}
            <div class="ld ld-ring ld-spin-fast"></div>
          </button>
        </div>
      </div>

      <draggable
        v-if="separator.in && sortList.length > 1"
        class="list-group unselect"
        tag="transition-group"
        :component-data="{
          tag: 'div',
          type: 'transition-group',
          name: !drag ? 'flip-list' : null,
        }"
        v-model="sortList"
        v-bind="dragOptions"
        @dragend="sortValues"
        @start="drag = true"
        @end="drag = false"
        item-key="id"
      >
        <template #item="{ element }">
          <div :class="{ hidden: element.hidden }"
              class="list-group-item">
            <span
              @click="sortValues(element.id)"
              >{{ element.value }}</span>
          </div>
        </template>
      </draggable>
    </div>

    <a class="hide" ref="exportLink"></a>
  </div>
</template>

<script>
import moment from 'moment';
import draggable from 'vuedraggable';
import { directive } from 'vue-tippy';
import 'tippy.js/themes/material.css';
import 'tippy.js/animations/shift-away.css';

export default {
  components: {
    draggable,
  },

  directives: {
    tippy: directive,
  },

  data() {
    return {
      drag: false,
      waitResponseCSV: false,
      inputData: '',
      outputData: [],
      sortList: [],
      separator: {
        in: ';',
        out: ';',
      },
    };
  },

  computed: {
    inputDataCount() {
      return this.inputData.split('\n').filter((n) => n).length;
    },
    outputDataCount() {
      return this.outputData.length;
    },
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
      };
    },
  },

  methods: {
    clearData() {
      this.inputData = '';
      this.outputData = [];
      this.sortList = [];

      const converterData = JSON.parse(localStorage.converterData);
      delete converterData.in;
      delete converterData.out;
      delete converterData.sortList;
      localStorage.converterData = JSON.stringify(converterData);

      this.$refs.inputData.focus();
    },

    syncIO(e) {
      const eventTarget = e.target.id;
      const scrollTop = e.target.scrollTop;

      if (eventTarget === 'inputData') {
        this.$refs.outputData.scrollTop = scrollTop;
      } else {
        this.$refs.inputData.scrollTop = scrollTop;
      }
    },

    beautyOut(values) {
      return values
        .filter((v) => !v.hidden)
        .map((v) => v.value)
        .join(this.separator.out);
    },

    selectSeparator(e) {
      e.target.select();
    },

    converting() {
      const separator = this.separator.in.replace(/(?=\W)/g, '\\');
      // const re = new RegExp(`(\\w)${separator}(\\S)`, 'g');
      const re = new RegExp(`([^"'])${separator}([^"'\\/\\s])`, 'g');

      console.log(
        this.inputData
          .split('\n')
          .filter((f) => f)
          .map((v, i) => {
            const replace = v.replace(re, '$1###$2');

            // console.log('replace', v.replace(re, '$1###$2'));

            // return {
            //   id: i + 1,
            //   values: replace
            //     .find((f) => f.includes('###'))
            //     .split('###')
            //     .map((v, i) => {
            //       return {
            //         id: i + 1,
            //         hidden: false,
            //         value: v,
            //       };
            //     }),
            // };

            if (replace.includes('###')) {
              return {
                id: i + 1,
                values: replace.split('###').map((v, i) => {
                  return {
                    id: i + 1,
                    hidden: false,
                    value: v,
                  };
                }),
              };
            } else {
              return;
            }

            // return {
            //   id: i + 1,
            //   values: v
            //     .replace(re, '$1###$2')
            //     .split('###')
            //     .map((v, i) => {
            //       return {
            //         id: i + 1,
            //         hidden: false,
            //         value: v,
            //       };
            //     }),
            // };
          })
      );

      const outputData = this.inputData
        .replace(re, '$1###fbrip###$2')
        .split('\n')
        .filter((f) => f.includes('###fbrip###'))
        .map((v, i) => {
          return {
            id: i + 1,
            values: v.split('###fbrip###').map((v, i) => {
              return {
                id: i + 1,
                hidden: false,
                value: v,
              };
            }),
          };
        });
      this.outputData = outputData;

      const sortList = this.inputData
        .replace(re, '$1###fbrip###$2')
        .split('\n')[0]
        .split('###fbrip###')
        .map((v, i) => {
          const val = v.length > 20 ? `${v.substr(0, 20).trim()}...` : v;
          return {
            id: i + 1,
            hidden: false,
            value: val,
          };
        });

      if (this.separator.in) {
        this.sortList = sortList;
      }


      // Удаляем пустые строки в inputData
      // this.inputData = this.inputData
      //   .split('\n')
      //   .filter((f) => f)
      //   .join('\n');

      // console.log('sortList', sortList);

      const tempData = {
        in: this.inputData,
        out: this.outputData,
        sortList,
        separator: {
          in: this.separator.in,
          out: this.separator.out,
        },
      };

      localStorage.converterData = JSON.stringify(tempData);
    },

    sortValues(elementId) {
      // Скрываем/Показываем отсортированные элементы в outputData при клике
      if (Number(elementId)) {
        const currentHidden = this.sortList.find((v) => v.id === elementId);
        currentHidden.hidden = !currentHidden.hidden;
      }

      this.outputData.map((od) => {
        // Устанавливаем сатус видимости элементов сортровки
        this.sortList.map((sl) => {
          const setCurrentHidden = od.values.find((v) => v.id === sl.id);

          if (setCurrentHidden) {
            setCurrentHidden.hidden = sl.hidden;
          }
        });

        // Сортируем outputData на основе id сортированного списка
        const orderedValues = this.sortList.map((v) => v.id);
        const sortArray = orderedValues.reduce(
          (r, e, i) => Object.assign(r, { [e]: i }),
          {}
        );
        od.values.sort((a, b) => sortArray[a.id] - sortArray[b.id]);
      });

      // Сохраняем измененный список сортировки в локал сторедж
      const converterData = JSON.parse(localStorage.converterData);
      converterData.sortList = this.sortList;
      localStorage.converterData = JSON.stringify(converterData);

      // console.log('modify-sortList', this.sortList);
    },

    saveSeparatorOut() {
      const converterData = JSON.parse(localStorage.converterData);
      converterData.separator.out = this.separator.out;
      localStorage.converterData = JSON.stringify(converterData);
    },

    dataPositionStart() {
      this.$refs.outputData.scrollTop = 0;
    },

    // Копирование данных в буфер
    async copyTextToClipboard() {
      // console.log(e.target.$tippy.hide());

      // setTimeout(() => {
      //   e.target._tippy.hide();
      // }, 1000);

      const filteringData = this.outputData.map((v) =>
        v.values.filter((f) => !f.hidden).map((v) => v.value)
      );

      const txtContent = filteringData
        .map((e) => e.join(this.separator.out))
        .join('\n');
      // const copy =  navigator.clipboard.writeText(data);
      // console.log(copy);
      navigator.clipboard
        .writeText(txtContent)
        .then(() => {
          console.log('copy');
          return true;
        })
        .catch(() => {
          console.log('error copy');
          return false;
        });
    },

    async exportTXT() {
      this.waitResponseCSV = true;

      const exportDate = moment().format();

      const filteringData = this.outputData.map((v) =>
        v.values.filter((f) => !f.hidden).map((v) => v.value)
      );

      const txtContent = filteringData
        .map((e) => e.join(this.separator.out))
        .join('\n');

      const blob = new Blob([txtContent], { type: 'text/plain' });
      const link = this.$refs.exportLink;
      link.href = window.URL.createObjectURL(blob);
      link.download = `export_converter.${exportDate}(checker.fb.rip).txt`;
      link.click();
      this.waitResponseCSV = false;
    },
  },

  mounted() {
    this.$refs.inputData.focus();
    const converterData = localStorage.converterData;

    if (converterData && JSON.parse(converterData).in) {
      this.inputData = JSON.parse(converterData).in;
    }

    if (converterData && JSON.parse(converterData).out) {
      this.outputData = JSON.parse(converterData).out;
    }

    if (converterData && JSON.parse(converterData).separator) {
      this.separator.in = JSON.parse(converterData).separator.in;
      this.separator.out = JSON.parse(converterData).separator.out;
    }

    if (converterData && JSON.parse(converterData).sortList) {
      this.sortList = JSON.parse(converterData).sortList;
      this.sortValues();
    }

    console.log(this.sortList)
  },
};
</script>

<style scoped>
.hide {
  display: none;
}

.hidden {
  background: red !important;
  opacity: 0.5;
}

.res {
  gap: 5px;
  flex-flow: nowrap;
  align-items: unset;
}

.separator {
  display: flex;
  align-items: center;
  /* margin: 5px 0 0 0; */
}

.separator > input {
  width: 50px;
  text-align: center;
  margin: 0 10px 0 0;
  padding: 5px;
  border: 2px solid grey;
  border-radius: 5px;
  /* outline: 0; */
  outline-color: #28a0a0;
  font-family: inherit;
  font-size: inherit;
}

.separator > p {
  font-size: 14px;
}

.list-group {
  display: flex;
  gap: 5px;
  flex-direction: row;
  flex-flow: row wrap;
  margin: 10px 0 0 0;
}

.list-group-item {
  background: #818181;
  padding: 5px 10px;
  color: white;
  border-radius: 5px;
  cursor: move;
}

.ghost {
  opacity: 0.5;
  background: #818181;
}

.line {
  font-weight: bold;
  color: #000;
  white-space: nowrap;
}
</style>
